import { useState, useEffect } from "react";

// services
import { mapgisSeg } from "../services/mapgisSeg";

export const usePermisions = (idComponente) => {
  const [permisos, setPermisos] = useState({
    superAdmin: false,
    admin: false,
    publico: false,
  });

  const [infoUser, setInfoUser] = useState(null);

  const consultarToken = async () => {
    try {
      const responseToken = await mapgisSeg("validacionToken.do", {
        app: process.env.REACT_APP_ID_APP,
      });
      if (responseToken !== "Sin autenticacion") {
        const responseDecodeJwt = await mapgisSeg("validarToken.do", {
          token: responseToken,
        });
        const adminPerfil = responseDecodeJwt.perfiles.find(
          (perfil) => perfil.idPerfil === 10001
        );

        const publicoPerfil = responseDecodeJwt.perfiles.find(
          (perfil) => perfil.idPerfil === 10002
        );

        const superAdmin = responseDecodeJwt.perfiles.find(
          (perfil) => perfil.idPerfil === 10008
        );

        localStorage.setItem("superAdmin", superAdmin ? true : false);
        localStorage.setItem("usuarioPublico", publicoPerfil ? true : false);
        localStorage.setItem("usuarioAdmin", adminPerfil ? true : false);
        localStorage.setItem("sinUsuario", false);

        setPermisos({
          superAdmin: superAdmin ? true : false,
          admin: adminPerfil ? true : false,
          publico: publicoPerfil ? true : false,
        });

        setInfoUser(responseDecodeJwt.idUsuario);
      } else {
        setPermisos({ superAdmin: false, admin: false, publico: false });
        localStorage.setItem("superAdmin", false);
        localStorage.setItem("usuarioPublico", false);
        localStorage.setItem("usuarioAdmin", false);
        localStorage.setItem("sinUsuario", true);
      }
    } catch (error) {
      setPermisos({ superAdmin: false, admin: false, publico: false });
      setInfoUser({ superAdmin: false, admin: false, publico: false });
      localStorage.setItem("usuarioPublico", false);
      localStorage.setItem("usuarioAdmin", false);
      localStorage.setItem("superAdmin", false);
      localStorage.setItem("sinUsuario", true);
    }
  };

  useEffect(() => {
    consultarToken();
  }, [idComponente]);

  return {
    permissions: permisos,
    infoUser,
  };
};
